// @flow
import IBAN from "iban";

import type { IConstraintModel } from "../../types";

/**
 */
class IBANConstraint implements IConstraintModel {
  /**
   */
  get id(): string {
    return "Constraint.IBAN.InvalidFormat";
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must be a valid IBAN number";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  validate(value: string): any {
    return IBAN.isValid(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default IBANConstraint;
